module.exports = __webpack_public_path__ + "static/img/reimaging-onboarding-data01.1ba7966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/reimaging-onboarding-data01.png
// module id = sOid
// module chunks = 1